import { Radio } from 'antd'

import { connect } from '@eastcoal/formily/exports/react'
import { FormilyProps } from '@eastcoal/formily/types/component'

const options = [
  {
    label: '顶部对齐',
    value: 'top'
  },
  {
    label: '垂直居中',
    value: 'middle'
  },
  {
    label: '底部对齐',
    value: 'bottom'
  }
]

const Component = (props: FormilyProps) => {
  return <Radio.Group {...props} options={options} />
}

export const VerticalAlignRadioGroup = connect(Component)
